import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRefetchOnAliveUpdate, type PullRequestAliveData} from './use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from './use-invalidate-on-alive-update'
import {useLabelsQuery} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.labels_updated)

export function useLabelsLiveUpdates(aliveChannels: AliveChannels): void {
  const {refetch, queryKey} = useLabelsQuery()
  const dedupeConcurrentRefetches = isFeatureEnabled('merge_status_checks_refetch_dedupe')

  // Original refetch path (flag OFF); empty channel no-ops it when ON.
  useRefetchOnAliveUpdate(dedupeConcurrentRefetches ? '' : aliveChannels.pullRequest, refetch, {labels_updated: true})

  // Additive dedupe path (flag ON); empty channel no-ops it when OFF.
  useInvalidateOnAliveUpdate(dedupeConcurrentRefetches ? aliveChannels.pullRequest : '', queryKey, {
    filter,
  })
}
